export const URL = "https://back-end-node-w7ym.vercel.app";

// https://back-end-node-kappa.vercel.app

// https://api-karaoke.onrender.com

// http://localhost:5000
